// Minimum eight characters, at least one letter and one number:
const passRegExp = new RegExp(
  '^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d@$!%*#?&]{8,}$'
);

export const passwordField = {
  name: 'password',
  minLength: 8,
  maxLength: 40,
  pattern: passRegExp.source, // '(\\d+[a-zA-Z]+)|([a-zA-Z]+\\d+)', // '[a-zA-Z0-9]+',
  required: true,
  title:
    'The password may contain letters, special symbols and at least one digit',
  type: 'password',
};

export const phoneField = {
  name: 'mobileNumber',
  minLength: 7,
  maxLength: 13,
  pattern: '^\\+\\d+$',
  required: true,
  title: 'The password must contain only digits and must start with "+"',
  type: 'tel',
};

export const firstNameField = {
  name: 'firstName',
  minLength: 2,
  maxLength: 49,
  required: true,
  pattern: '^[^\\s]+$',
  title: 'First name cannot contain spaces',
};

export const lastNameField = {
  name: 'lastName',
  minLength: 2,
  maxLength: 49,
  required: true,
  pattern: '^[^\\s]+$',
  title: 'Last name cannot contain spaces',
};

export const inventoryTitleField = {
  name: 'title',
  maxLength: 49,
  required: true,
};

export const inventoryNotesField = {
  name: 'notes',
  maxLength: 200,
};
